// @ts-nocheck
import { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import "../../assets/functionalComponents/_dialog.scss"
import "../../assets/functionalComponents/_dataItem.scss"

export const OGCI3SOption = (props) => {
    const [layer, setLayer] = useState({});

    useEffect(() => {
        setLayer(props.layer);
    }, [props.layer])

    const layerGoto = () => {
        layer.layerObject.goto();
    }

    return (
        <div>
            <div className="layer-item">
                <div className="layer-detail">
                    <div className="layer-name">{layer.TITLE}</div>
                </div>
                <div className="layer-action">
                    <Button icon="pi pi-cog" className="p-button-rounded p-button-info" disabled />
                    <Button icon="pi pi-map-marker" className="p-button-rounded p-button-info" onClick={() => { layerGoto() }} />
                    <Button icon="pi pi-times" className="p-button-rounded p-button-danger" onClick={() => { props.layerRemove(props.index) }} />
                </div>
            </div>
            <Divider />
        </div>
    )
}